<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  dialogSize="large"
  [loading]="loading()"
>
  <span bitDialogTitle class="tw-font-medium">
    {{ "restartSubscription" | i18n }}
  </span>
  <div bitDialogContent>
    @if (!loading()) {
      @if (restartPlan(); as plan) {
        <div class="tw-mb-4">
          <span class="tw-text-sm tw-text-muted">{{ "plan" | i18n }}</span>
          <p class="tw-mb-0 tw-font-medium tw-text-main">
            {{ plan.nameLocalizationKey | i18n }} ·
            {{ (plan.isAnnual ? "annually" : "monthly") | i18n }}
          </p>
        </div>
      }
      <app-enter-payment-method [group]="formGroup.controls.paymentMethod">
      </app-enter-payment-method>
      <app-enter-billing-address
        [group]="formGroup.controls.billingAddress"
        [scenario]="{ type: 'checkout', supportsTaxId: supportsTaxId() }"
      >
      </app-enter-billing-address>
      @if (restartCart.isLoading()) {
        <div class="tw-mt-4 tw-text-center">
          <bit-spinner></bit-spinner>
        </div>
      } @else if (restartCart.error() != null) {
        <bit-callout type="danger" class="tw-mt-4 tw-block">
          {{ previewErrorMessageKey() | i18n }}
          @if (previewRetryable()) {
            <button
              id="restart-subscription-dialog_button_retry-preview"
              bitLink
              linkType="primary"
              type="button"
              (click)="retryPreview()"
            >
              {{ "tryAgain" | i18n }}
            </button>
          }
        </bit-callout>
      } @else if (restartCart.hasValue()) {
        <div class="tw-mt-4">
          <billing-cart-summary [cart]="restartCart.value()" />
        </div>
      }
      @if (addressLoadFailed()) {
        <bit-callout type="danger" class="tw-mt-4 tw-block">
          {{ "restartSubscriptionBillingAddressLoadError" | i18n }}
        </bit-callout>
      }
    }
  </div>
  <ng-container bitDialogFooter>
    <button
      id="restart-subscription-dialog_button_restart"
      bitButton
      bitFormButton
      buttonType="primary"
      type="submit"
      [disabled]="restartDisabled()"
    >
      {{ "restart" | i18n }}
    </button>
    <button
      id="restart-subscription-dialog_button_cancel"
      bitButton
      buttonType="secondary"
      type="button"
      [bitDialogClose]="ResultType.Closed"
    >
      {{ "cancel" | i18n }}
    </button>
  </ng-container>
</form>
